import { useCallback, useState } from "react";
import { RepairForm } from "types/restarter";

type FormSubmissionStatus = "" | "SUCCESS" | "ERROR";

type ReturnType = {
  loading: boolean;
  formSubmitted: FormSubmissionStatus;
  submitRestarterForm: (formData: RepairForm) => Promise<boolean>;
};

export const useRestarterForm = (): ReturnType => {
  const [loading, setLoading] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState<FormSubmissionStatus>("");

  const submitRestarterForm = useCallback(async (formData: RepairForm) => {
    setLoading(true);
    setFormSubmitted("");
    const url = `${import.meta.env.REACT_APP_REST_URL}/v1/restarter/repairForm`;
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      setFormSubmitted("SUCCESS");
      return true;
    } catch (error) {
      console.error("Failed to submit the repair form:", error);
      setFormSubmitted("ERROR");
      return false;
    } finally {
      setLoading(false);
    }
  }, []);

  return { submitRestarterForm, loading, formSubmitted };
};
